import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import urls from "../../config/urls.json";
import { useSession } from "../../hooks/useSession";
import { useStates } from "../../hooks/useStates";
import { ApiService as api } from "../../services/ApiService";
import { getYMD } from "../../services/formatters";
// import { useCodiceFiscalePage } from "../CodiceFiscalePage/useCodiceFiscalePage";
import { useDynatrace } from "../../hooks/useDynatrace";
import { useEditAppointment } from "../../hooks/useEditAppointment";
import useLog from "../../hooks/useLog";

export const useFilialiPage = () => {
    const { branchSelectionEvent} = useLog();
    const [currentMapToShow, setCurrentMapToShow] = useState("");
    const { askForEditAppointment, showModal, closeModal } = useEditAppointment();

    const navigate = useNavigate();
    const { read, update, batchUpdate, canISkipCfPage } = useSession();
    const { states, setCurrentState, isFilialiSlideBusy, isCfPageReady } = useStates();
    // const { nextForExternalCf } = useCodiceFiscalePage();

    const [fetchError, setFetchError] = useState(false);
    const [fetchErrorMessage, setFetchErrorMessage] = useState("");

    let subSlider = useRef();
    let daySlider = useRef();

    useEffect(() => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);

        if (read("oppID") || read("oppID_external")) {
            setCurrentState(states.FETCH_CF_EDIT_APPOINTMENT);
            askForEditAppointment();
            return;
        }
    }, []);

    const {} = useDynatrace();
    
    const next = () => {
        branchSelectionEvent();

        if (canISkipCfPage()) {
            setCurrentState(states.FETCH_CF_END);
            if (true == read("ricontattoCf") && true == read("ricontattoLuogo")) {
                update("ricontatto", true);
                navigate(urls.clink.path);
            } else if (true == read("utenteRiconosciuto")) {
                navigate(urls.datiPersonaliRiconosciuto.path);
            } else {
                navigate(urls.datiPersonaliNonRiconosciuto.path);
            }
        } else {
            navigate(urls.codiceFiscale.path);
        }
    };

    const currentSlideFiliale = useRef("");
    const onFilialiSlideChange = async (filialeIdx) => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_START);
        const currFiliale = read("filiali")[filialeIdx];
        const idCurrFiliale = currFiliale.codFiliale;

        currentSlideFiliale.current = idCurrFiliale; // 719 > 729

        const filiale = await api.GetFiliale({ Codice: idCurrFiliale }, currFiliale);

        console.log("precheck", filiale.codFiliale);
        if (currentSlideFiliale.current != filiale.codFiliale) return;
        console.log("post check", filiale.codFiliale);

        batchUpdate({
            filialeScelta: currFiliale,
            disponibilita: filiale.days,
            dataScelta: filiale.days[0],
        });
        // force change on giorniSlider to automate call to Disponibilita
        if (daySlider && daySlider.current) {
            daySlider.current.go(0);
            // if already at index 0, the previous line won't trigger the splide change, hence we need to force it
            if (daySlider.current.splide.index == 0) {
                onGiorniSlideChange(0);
            }
        }
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);
    };

    const onGiorniSlideChange = async (giornoIdx) => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_START);
        update("dataScelta", read("disponibilita")[giornoIdx]);

        // call new Disponibilita
        let disponibilitaResult = {};
        try {
            const TipoFiliali = read("prodotto") == 3 ? 1 : 0;
            disponibilitaResult = await api.Disponibilita({
                CodFiliale: read("filialeScelta").codFiliale,
                Giorno: getYMD(read("dataScelta").data),
                TipoFiliali,
            });
        } catch (error) {
            setFetchErrorMessage("C'è stato un errore nel caricamento delle disponibilità delle filiali. <br />Per favore riprova.");
            setFetchError(true);
            return;
        }

        update("orari", disponibilitaResult.orariDisponibili);

        let favouriteHour = disponibilitaResult.orariDisponibili.filter((_) => _.disponibile == true)[0];
        let eligibleOrarioScelto = [];
        if (read("orarioScelto")) {
            eligibleOrarioScelto = disponibilitaResult.orariDisponibili.filter((_) => _.disponibile == true && _.hour == read("orarioScelto").hour && _.minute == read("orarioScelto").minute);
        }
        if (eligibleOrarioScelto.length > 0) {
            favouriteHour = eligibleOrarioScelto[0];
        }

        update("orarioScelto", favouriteHour);
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);
    };

    const showMap = (id, coords) => {
        if (currentMapToShow.length) {
            setCurrentMapToShow("");
            destroyMap(id);
        } else {
            setCurrentMapToShow(id);
            renderMap(id, coords);
        }
    };
    const renderMap = (id, coords) => {
        const appleMapManager = window.AppleMapManager();
        appleMapManager.renderMap(id, {
            latitude: coords.lat,
            longitude: coords.lng,
        });
    };
    const destroyMap = (id) => {
        setTimeout(() => {
            const mapNode = document.getElementById(id);
            mapNode.innerHTML = "";
        }, 500);
    };

    return {
        next,
        read,
        update,
        subSlider,
        daySlider,
        onFilialiSlideChange,
        onGiorniSlideChange,
        isFilialiSlideBusy,
        isCfPageReady,
        showMap,
        currentMapToShow,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
    };
};
